module.exports = __webpack_public_path__ + "static/media/google-icon-new.9beb39e5.png";